module.exports = __webpack_public_path__ + "static/media/10.738b2806.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/10.jpg
// module id = 185
// module chunks = 0